import { User } from '../interfaces';

export const TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'bfsg_refresh-token';
export const USER_AUTH = 'bfsg_user-auth';

export default class UserHandler {
  private static instance: UserHandler | undefined;

  private constructor() {
    console.log('UserHandler init...');
  }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new UserHandler();
    }
    return this.instance;
  }

  public static clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_AUTH);
  }

  public get token(): string {
    return localStorage.getItem(TOKEN_KEY) ?? '';
  }

  public set token(value: string) {
    localStorage.setItem(TOKEN_KEY, value);
  }

  public get refreshToken(): string {
    return localStorage.getItem(REFRESH_TOKEN_KEY) ?? '';
  }

  public set refreshToken(value: string) {
    localStorage.setItem(REFRESH_TOKEN_KEY, value);
  }

  public get user(): User {
    return JSON.parse(localStorage.getItem(USER_AUTH) ?? '{}');
  }

  public set user(value: User) {
    localStorage.setItem(USER_AUTH, JSON.stringify(value));
  }

  public get role(): string {
    return this.user.role;
  }
}
